import React, { useState, useEffect, useRef } from 'react';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import classNames from 'classnames';
import defaultConfig from '../../config/configDefault';

import css from './TextEditor.module.css';

let Editor = null;
if (typeof window !== 'undefined') {
  Editor = require('react-draft-wysiwyg').Editor;
}

const TextEditor = props => {
  const { fieldValue, label, placeholder, input, meta } = props;

  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [focused, setFocused] = useState(false);
  const editorRef = useRef();

  useEffect(() => {
    if (!!fieldValue?.length) {
      const contentForOldListing = {
        entityMap: {},
        blocks: [
          {
            key: '637gr',
            text: `${fieldValueToString.replaceAll('"', '')}`,
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {},
          },
        ],
      };

      if (validContent) {
        const content = convertFromRaw(JSON.parse(fieldValue));
        const editorStateInitialValues = EditorState.createWithContent(content);
        setEditorState(editorStateInitialValues);
      } else {
        setEditorState(EditorState.createWithContent(convertFromRaw(contentForOldListing)));
      }
    }
  }, []);

  const fieldValueToString = !!fieldValue ? JSON.stringify(fieldValue) : JSON.stringify('');
  const fieldValueToObject = JSON.parse(fieldValueToString);
  const validContent = fieldValueToObject.indexOf('blocks') !== -1;

  const handleEditorChange = state => {
    setEditorState(state);

    const content = convertToRaw(state.getCurrentContent());
    const serialized = JSON.stringify(content);
    input.onChange(serialized);
  };

  const focusEditor = () => {
    if (editorRef.current) {
      editorRef.current.focusEditor();
    }
  };

  const editorToolbarOptions = defaultConfig.editorToolbarOptions;
  const editor = classNames(css.editor, {
    [css.focusedEditor]: focused,
    [css.errorEditor]: meta.touched && meta.error,
  });

  if (!Editor) {
    return null;
  }

  return (
    <div className={css.root}>
      {label && <label onClick={focusEditor}>{label}</label>}
      <Editor
        ref={editorRef}
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        toolbar={editorToolbarOptions}
        wrapperClassName={css.editorWrapper}
        editorClassName={editor}
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setFocused(false);
          input.onBlur();
        }}
        placeholder={placeholder || null}
        stripPastedStyles={true}
      />

      {meta.touched && meta.error && <span className={css.error}>{meta.error}</span>}
    </div>
  );
};

export default TextEditor;
